<template>
  <v-card-text>
    <v-select
      v-model="viewStyle.referenceProperty"
      hide-details
      item-value="key"
      item-text="value"
      label="Поле, значение которого будет использоваться в надписи"
      no-data-text="Необходимо заполнить список полей"
      :items="mappings"
    />

    <v-menu
      :close-on-content-click="false"
      offset-x
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :color="viewStyle.color"
          :class="[`${getTextColor(viewStyle.color)}--text`]"
          class="mt-5 mr-4"
          small
          rounded
          dark
          v-bind="attrs"
          v-on="on"
        >
          Выбрать цвет текста
        </v-btn>
      </template>

      <v-card>
        <v-color-picker
          v-model="viewStyle.color"
          mode="rgba"
          flat
        />
      </v-card>
    </v-menu>

    <v-menu
      :close-on-content-click="false"
      offset-x
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :color="viewStyle.haloColor"
          :class="[`${getTextColor(viewStyle.haloColor)}--text`]"
          class="mt-5"
          small
          rounded
          dark
          v-bind="attrs"
          v-on="on"
        >
          Выбрать цвет контура
        </v-btn>
      </template>

      <v-card>
        <v-color-picker
          v-model="viewStyle.haloColor"
          mode="rgba"
          flat
        />
      </v-card>
    </v-menu>

    <v-slider
      v-model="viewStyle.size"
      class="mt-4"
      label="Размер текста"
      thumb-label
      hide-details
      max="20"
      min="8"
    />

    <v-slider
      v-model="viewStyle.minZoom"
      label="Минимальное значение отдаления камеры для отображения"
      step="1"
      min="1"
      max="22"
      class="mt-4"
      thumb-label
    />

    <v-checkbox
      v-model="viewStyle.overlap"
      label="Разрешить наложение надписей друг на друга"
      hide-details
    />
  </v-card-text>
</template>

<script>
import getTextColor, { getHexColor } from '@/utils/get-text-color';

export default {
  props: {
    viewStyle: {
      type: Object,
      required: true,
    },
    mappings: {
      type: Array,
      default: () => [],
    },
  },

  created() {
    this.fixColor();
  },

  methods: {
    getTextColor,

    fixColor() {
      this.viewStyle.color = getHexColor(this.viewStyle.color);
      this.viewStyle.haloColor = getHexColor(this.viewStyle.haloColor);
    },

  },
};
</script>
